<template>
  <v-container
    fill-height
    justify-content-start
    :class="{ 'pa-2': $vuetify.breakpoint.xsOnly }"
    class="app-section-width"
  >
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="$router.go(-1)">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{category ? category.name : getDashboardName({url: '/activity-categories'})}}</v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section pa-2">
        <v-layout row>
          <v-flex xs12 sm6 v-for="(item, index) in activities" :key="index" :set="reservationMethods = getActiveReservationMethods(item)">
            <div
              class="activity-button ma-1 pt-3 clickable"
              @click="goTo(item.activity.id)"
              :style="{
                'background-image':
                  'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' +
                  item.activity.coverImageUrl +
                  ')',
              }"
            >
              <v-layout class="activity-name mb-1">
                <div class="activity-title">{{ item.activity.name }}</div>
              </v-layout>
              <v-layout wrap v-if="reservationMethods.length > 0">
                <p class="mb-1 activity-title">
                  <span v-for="(extendedReservationMethod, i) in reservationMethods" :key="i">
                    <span>{{ i === 0
                      ? $t(`activities.reservation_types.${extendedReservationMethod.reservationMethod.type}`)
                      : $t(`activities.reservation_types.${extendedReservationMethod.reservationMethod.type}`).toLowerCase() }}</span>
                    <span v-if="(i + 1) !== reservationMethods.length" class="show-spaces"> & </span>
                  </span>
                </p>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '@/router/routes'
import router from '@/router'
import { mapGetters, mapState } from 'vuex'
export default {
  data () {
    return {
      activities: [],
    }
  },
  created () {
    this.$store.dispatch('activities/listCategories').then(() => {
      this.$store.dispatch('activities/listActivities').then(() => {
        this.activities = this.activitiesByCategory(
          this.$route.params.categoryId
        )
      })
    })
  },
  methods: {
    goTo (id) {
      router.push({
        name: routeNames.activity_details.name,
        params: { categoryId: this.$route.params.categoryId, activityId: id },
      })
    },
    getActiveReservationMethods (item) {
      return item.reservationMethods.filter(extendedReservationMethod => extendedReservationMethod.reservationMethod.active)
    },
  },
  computed: {
    ...mapState({
      categories: state => state.activities.categories,
    }),
    ...mapGetters({
      activitiesByCategory: 'activities/activitiesByCategory',
      getDashboardName: 'service/getDashboardName',
    }),
    category () {
      return this.categories.find((c) => { return c.id === this.$route.params.categoryId })
    },
  },
  beforeDestroy () {
    this.$store.commit('activities/resetActivityData')
  },
}
</script>

<style lang="scss" scoped>
.activity-name {
  position: relative;
  max-width: fit-content;
  :first-child {
    background: none;
    font-size: 22px;
    max-width: 100%;
    display: inline-block;
    font-weight: 500;
    z-index: 1;
  }
  ::after {
    content: '';
    width: 100%;
    height: 100%;
    background-color: var(--v-primary-darken1);
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>
